export const marimbaSound = "/assets/sounds/marimba-ringtone.mp3";
export const callingSound = "/assets/sounds/phone-calling.mp3";

export const playSound = (soundFile) => {
  const audio = new Audio(soundFile);
  audio.volume = 0.5;
  audio.play();
};

/**
 * Initializes an HTML audio element with the given id and sound path.
 * If the element with the given id already exists, it is reused.
 * Otherwise, a new element is created, appended to the document body,
 * and returned.
 *
 * @param {string} id - The id of the audio element.
 * @param {string} soundPath - The path to the sound file.
 * @returns {HTMLAudioElement} The initialized audio element.
 */
const initializeAudioElement = (id, soundPath) => {
  let audioElement = document.getElementById(id);

  if (!audioElement) {
    audioElement = document.createElement("audio");
    audioElement.id = id;
    audioElement.src = soundPath;
    audioElement.style.display = "none";
    document.body.appendChild(audioElement);
  }

  return audioElement;
};

/**
 * Plays a sound from the specified sound path safely.
 * Initializes an audio element if not already present and attempts
 * to play the sound. Logs an error message if playback fails.
 *
 * @param {string} soundPath - The path to the sound file to be played.
 */

export const playSoundSafely = (soundPath) => {
  const audioElement = initializeAudioElement("notificationAudio", soundPath);

  audioElement.play().catch((error) => {
    console.error("Failed to play sound:", error.message);
  });
};
